<template>
  <div class="relative flex flex-col min-w-0 break-words w-full p-4 shadow-lg rounded-lg bg-white">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray mb-1 text-xs font-semibold">
            Total Number of Classrooms
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Overview of Classroom
          </h2>
        </div>
        <div class="relative w-full max-w-full flex-grow flex-1 text-right">
          <button @click="toggleAccordion(1)" class="accordion-header cursor-pointer bg-blueGray-600 text-sm text-white active:bg-blueGray-100 px-3 shadow-lg
          py-1 rounded outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button"> 
          All Usage Data </button>
        </div>
      </div>
    </div>
  <div v-if="showAccordion[1]" class="accordion-content">
    <div class="flex-auto w-full h-350-px overflow-x-auto text-center text-sm rounded-lg shadow">      
      <table class="table-auto w-full bg-transparent border-collapse">
        <thead class="sticky top-0">
          <tr>
            <th
              class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold bg-blueGray-200 text-blueGray-500">
              No.
            </th>
            <th
              class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold bg-blueGray-200 text-blueGray-500">
              List
            </th>
            <th
              class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold  bg-blueGray-200 text-blueGray-500">
              Use (Times)
            </th>
            <th
              class="px-4 align-middle border border-solid py-2 border-l-0 border-r-0 whitespace-nowrap font-semibold bg-blueGray-200 text-blueGray-500">
              Use Time (Hours)
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="resource_detail_arr.length === 0">
              <td colspan="4" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
          </tr>
          <tr v-for="(resource_detail, index) in resource_detail_arr" :key="index">
            <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
              {{resource_detail.num}}
            </td>
            <td class="border-t-0 px-6 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-left">
              {{resource_detail.name_room}}
            </td>
            <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
              {{resource_detail.sum_use}}
            </td>
            <td class="border-t-0 p-2 align-middle border-l-0 border-r-0 whitespace-nowrap text-center">
              {{resource_detail.sum_hour}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

    <div class="pt-6 flex-auto px-4">
      <div class="flex flex-wrap ">
        <div class="w-full lg:w-5/12 mr-auto px-4 pt-6 pb-4 h-full mb-2 shadow rounded-lg border-0 bg-emerald-200">
            <div  class="text-white p-3 text-center mr-2 mb-4 inline-flex items-center justify-center w-10 h-10 shadow-lg rounded-lg bg-emerald-500" >
              <i class="fas fa-arrow-up"></i>
            </div>          
            <span class="text-blueGray text-lg font-semibold text-blueGray">
              Top 5 Most Used
            </span>
            <div class="block w-full overflow-x-auto">
              <table class="items-center w-full pt-2 rounded-lg bg-white">
                <tbody>
                  <tr v-if="resource_top_arr.length === 0">
                    <td colspan="3" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                  </tr>
                  <tr v-for="(resource_top, index) in resource_top_arr" :key="index">
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left"
                    >
                      {{resource_top.name_room}}
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right"
                    >
                      {{resource_top.sum_hour}} Hours
                    </td>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right"
                    >
                      {{resource_top.sum_use}} Times
                    </td>
                  </tr>                  
                </tbody>
              </table>
            </div>      
        </div>

        <div class="w-full lg:w-5/12 px-4 pt-6 pb-4 h-full mb-2 shadow rounded-lg border-0 bg-red-200">
            <div  class="text-white p-3 text-center mr-2 mb-4 inline-flex items-center justify-center w-10 h-10 shadow-lg rounded-lg bg-red-500" >
              <i class="fas fa-arrow-down"></i>
            </div>          
            <span class="text-blueGray text-lg font-semibold text-blueGray">
              Top 3 Least Used
            </span>
            <div class="block w-full overflow-x-auto">
              <table class="items-center w-full pt-2 rounded-lg bg-white">
                <tbody>
                  <tr v-if="resource_min_arr.length === 0">
                    <td colspan="3" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                  </tr>
                  <tr v-for="(resource_min, index) in resource_min_arr" :key="index">
                    <th
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-left"
                    >
                      {{resource_min.name_room}}
                    </th>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right"
                    >
                      {{resource_min.sum_hour}} Hours
                    </td>
                    <td
                      class="border-t-0 px-4 align-middle border-l-0 border-r-0 text-xs whitespace-nowrap p-2 text-right"
                    >
                      {{resource_min.sum_use}} Times
                    </td>
                  </tr>          
                </tbody>
              </table>
            </div>      
          </div>
   

        
      </div>
    </div>
  </div>
</template>


<script>
import api from './../../services/student_services';
export default {
  name: "card-stats",
  data() {
    return {
      openTab: 1,      
      resource_detail_arr: [],
      resource_top_arr: [],
      resource_min_arr: [],
      showAccordion: {
        1: false,
        2: false,
        3: false
      }
    }
  },
  methods: {
    toggleAccordion(accordionNumber) {
      // กำหนดค่าให้กับคุณสมบัติที่เปิดหรือปิดของแต่ละ Accordion
      this.showAccordion[accordionNumber] = !this.showAccordion[accordionNumber];
    },
    async resource_room_detail() {
      api.resource_room_detail().then(async (result) => {        
        this.resource_detail_arr = result.data;
      });
    },
    async resource_room_top() {
      api.resource_room_top().then(async (result) => {        
        this.resource_top_arr = result.data;
      });
    },
    async resource_room_min() {
      api.resource_room_min().then(async (result) => {        
        this.resource_min_arr = result.data;
      });
    },
  }, created: async function () {
      await this.resource_room_detail(),
      await this.resource_room_top(),
      await this.resource_room_min()
  }
}
</script>